<div class="app-content"> 
    <partial-header></partial-header>
    <router-outlet></router-outlet>   
    <partial-footer></partial-footer>
</div>    
